<template>
  <!-- OVERLAY -->
  <div
    v-if="open"
    class="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm px-1"
    @click.self="close"
  >
    <!-- MODAL -->
    <div
      class="w-full max-w-lg rounded-2xl bg-[#0f172a] border border-white/10 p-6 shadow-xl"
    >
      <!-- HEADER -->
      <div class="flex items-center justify-between mb-6">
        <h2 class="text-lg font-semibold">Let’s Talk</h2>
        <button
          @click="close"
          class="text-white/60 hover:text-white text-xl"
        >
          ✕
        </button>
      </div>

      <div class="grid grid-cols-1 flex mb-6">
        <p class="mt-1">Questions, feedback, or ideas? Send us a message.</p>
      </div>
      <!-- FORM -->
      <form @submit.prevent="submit">
        <div class="grid grid-cols-1">
          <input
            id="text"
            ref="inputText"
            v-model="data.item.title"
            type="text"
            required
            placeholder="Title"
            maxlength="255"
            class="input rounded-xl bg-white/10 backdrop-blur px-2 py-3 mt-4"
          />
          
          <input
            v-model="data.item.email"
            type="text"
            required
            placeholder="Email"
            maxlength="255"
            class="input rounded-xl bg-white/10 backdrop-blur px-2 py-3 mt-4"
          />

          
          <textarea
              v-model="data.item.message"
              rows="3"
              maxlength="4096"
              placeholder="Enter your message here..."
              class="input resize-none rounded-xl bg-white/10 backdrop-blur px-2 py-3 mt-4"></textarea>

        </div>

        <!-- ACTIONS -->
        <div class="flex justify-end gap-3 mt-6">
          <div class="py-2 text-red-400" v-if="data.error">{{ data.error }}</div>
          <button
            type="button"
            @click="close"
            class="px-4 py-2 rounded-lg text-white/70 hover:text-white">
            Cancel
          </button>

          <button
            type="button"
            class="px-5 py-2 rounded-lg bg-cyan-400 text-black font-semibold hover:bg-cyan-300"
            @click.prevent="submit">
            Send
          </button>
        </div>
      </form>
    </div>
  </div>
</template>
<script lang="ts">
  import { watchEffect, reactive, watch, ref } from "vue"
  import contactusService from "@/services/contactus.service";

  const inputText = ref();
  export default {
    name: 'ContactUs',
    components: {
    },
    props: {
        // Define your props here
        open: {
            type: Boolean,
            required: true,
            default: false,
        }
    },
    emits: ["close", "submit"],
    setup(props: any,{emit}: any) {

      const data = reactive({
        item: {} as any,    
        error: "",
      })

      const close = () =>  {
        clearData();
        emit("close")
      }

      watchEffect(() => {
        if (inputText.value) {
          inputText.value.focus()
        }
      })

      // fechar com ESC
      watch(
        () => props.open,
        (value) => {
          if (value) {
            clearData();
            window.addEventListener("keydown", onEsc)
          } else {
            window.removeEventListener("keydown", onEsc)
          }
        }
      )

      const onEsc = (e: any) => {
        if (e.key === "Escape") close()
      }

      const clearData = () => {
        data.error = "";
        data.item = {}
      }

      const submit = () => {
          contactusService.insertItem(data.item, "contactus").then(async (response: any) => {
            if (response && response.data && response.data.data) {
              emit("submit", { ...data })
              close()
            }                    
          }).catch((error)  => {
            data.error = error.message;
          })
          
      }
             
      return { submit, data, close } ;
  }
}
</script>

<style scoped>
.input {
  @apply w-full rounded-xl bg-white/10 backdrop-blur px-4 py-3
         text-white placeholder-white/40
         focus:outline-none focus:ring-2 focus:ring-cyan-400;
  padding-left: 15px;
  padding-right: 15px;
}

@keyframes flip {
  0% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(90deg);
  }
  75% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(350deg);
  }
}

#hourglass,
#hourglass #upper-fill-clip,
#hourglass #lower-fill-clip {
  fill: #000000;
}

#hourglass {
  animation-name: flip;
  animation-duration: 3s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  transform-origin: center center;
}
</style>